import { render, staticRenderFns } from "./front-mainlandfreight.vue?vue&type=template&id=19e6397f&"
import script from "./front-mainlandfreight.vue?vue&type=script&lang=ts&"
export * from "./front-mainlandfreight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports